import React from 'react'
import HeaderOne from '../../common/header/HeaderOne'
import CustomFooter from "../../elements/CustomFooter/CustomFooter";
import Copyright from '../../common/footer/Copyright'
import './style.css'
import SEO from '../../common/SEO';

function FullStackNextDevelopment() {
  return (
    <>
      <SEO title="About Us" />
      <main className="page-wrapper">
        <HeaderOne btnStyle="btn-small round btn-icon" HeaderSTyle="header-transparent66" />
        <div className="slider-area slider-style-1 height-380 bg_image" data-black-overlay="1" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/banner/wordpressdev.jpg)` }}>
        </div>
        <div className='main_container_for_services'>
          <div className='inner_container_for_services'>
            <div style={{ height: '8px', width: '60px', background: '#00C896', marginBottom: '2rem' }}></div>            <h1>Full-Stack<br /> Development with<br /> Next.js</h1>
            <p style={{ marginBottom: '3.5rem' }}>Build scalable, end-to-end web apps using Next.js 14+ and modern JavaScript.</p>
            <h4>Tools</h4>
            <p style={{ marginBottom: '3.5rem' }}>Leverage Next.js as a unified full-stack framework to create high-performance, SEO-friendly applications with React Server Components, TypeScript APIs, and serverless backends. Seamlessly deploy your projects on Vercel's global edge network.</p>
            <h3>Why Businesses Choose Next.js Full-Stack Development</h3>
            <h4>All-in-One Architecture:</h4>
            <ul style={{ listStyleType: 'square' }}>
              <li>Consolidate frontend and backend teams with a single TypeScript codebase.</li>
              <li>Built-in API routes, middleware, and React Server Components (RSC) allow for efficient full-stack logic.</li>
            </ul>
            <h4>Blazing-Fast Performance:</h4>
            <ul style={{ listStyleType: 'square' }}>
              <li>Static Site Generation (SSG) and Incremental Static Regeneration (ISR) support dynamic content.</li>
              <li>Deploy globally with low latency using Edge runtime.</li>
            </ul>
            <h4>Enterprise Scalability:</h4>
            <ul style={{ listStyleType: 'square' }}>
              <li>Easily integrate serverless databases like PlanetScale (MySQL) or NeonDB (PostgreSQL).</li>
              <li>Auto-scaling APIs and Redis caching ensure high-traffic apps run smoothly.</li>
            </ul>
            <h4>Our Next.js Full-Stack Expertise</h4>
            <h4>What We Deliver</h4>
            <p style={{ marginBottom: '3.5rem' }}>We specialize in Next.js 14+ development, utilizing the App Router, Server Actions, Edge Functions, and middleware to build high-performance applications. Our backend integrations include tRPC/GraphQL APIs, Drizzle ORM, PostgreSQL/MySQL databases, and real-time WebSocket features for seamless data handling. For UI/UX, we use Tailwind CSS, the ShadCN/UI component library, and Framer Motion animations to create modern, interactive user interfaces. Our DevOps and deployment strategies leverage Vercel Edge Network for scalability, GitHub Actions for CI/CD automation, and Logflare for efficient monitoring.</p>
            <h4>Ideal for Complex Applications Like:</h4>
            <ul style={{ listStyleType: 'square' }}>
              <li>SaaS Platforms</li>
              <li>Real-Time Dashboards (Finance, Logistics)</li>
              <li>AI/ML-Powered Apps with Node.js Backends</li>
              <li>Enterprise Resource Planning (ERP) Tools</li>
            </ul>
          </div>
          <div className='thirdy_container_for_services'>
            <img src={`${process.env.PUBLIC_URL}/images/banner/e706a7a7f8c40253b619059af713eecd5d6d80fe-552x581.jpg`} />
          </div>
        </div>
      </main>
      <CustomFooter />
    </>
  )
}

export default FullStackNextDevelopment